<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke-width="1.5"
    stroke="currentColor"
    class="size-6"
    v-bind="$attrs"
  >
    <path
      stroke-linecap="round"
      stroke-linejoin="round"
      d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"
    />
  </svg>
</template>

<script>
export default {
  name: "Bars3Icon",
  inheritAttrs: false 
};
</script>



// WEBPACK FOOTER //
// src/components/icons/Bars3Icon.vue